const PROD_HOSTS = new Set(['luckywise360.com', 'www.luckywise360.com'])

const getCurrentHost = () => {
	if (import.meta.client) return window.location.hostname
	return useRequestURL().hostname
}

const isPreviewMode = () => {
	if (import.meta.client) {
		const qs = new URLSearchParams(window.location.search)
		return qs.has('gtm_preview') || qs.has('gtm_debug') || qs.has('gtm_auth') || window.gtm_enable_debug === true
	}

	const url = useRequestURL()
	return url.searchParams.has('gtm_preview') || url.searchParams.has('gtm_debug') || url.searchParams.has('gtm_auth')
}

export default defineNuxtPlugin(() => {
	const runtime = useRuntimeConfig().public
	const envName = String(runtime.envName || '')
	const host = getCurrentHost()
	const isProdHost = PROD_HOSTS.has(host)
	const isProduction = envName === 'production'
	const gtmEnabled = String(runtime.gtm?.enabled) === 'true'
	const gtmId = String(runtime.gtm?.id || '')
	const gtagId = String(runtime.gtag?.id || '')
	const debugPreview = String(runtime.gtm?.debug || 'false') === 'true'
	const allowLocalPreview = !isProdHost && debugPreview && isPreviewMode()

	if ((!isProduction || !isProdHost) && !allowLocalPreview) {
		return
	}

	if (!gtmEnabled || !gtmId) {
		return
	}

	const bootstrapCommands = [
		'window.dataLayer = window.dataLayer || [];',
		'function gtag(){dataLayer.push(arguments);}',
		`gtag('consent', 'default', {
          'ad_storage': 'denied',
          'analytics_storage': 'denied',
          'ad_user_data': 'denied',
          'ad_personalization': 'denied',
          'wait_for_update': 2000
        });`,
		"gtag('js', new Date());",
	]

	if (gtagId) {
		bootstrapCommands.push(`gtag('config', '${gtagId}');`)
	}

	useHead({
		script: [
			{
				key: 'gtm-bootstrap',
				innerHTML: bootstrapCommands.join('\n'),
				tagPriority: 'critical',
				tagPosition: 'head',
			},
			{
				key: 'gtm-script',
				src: `https://gtm.luckywise360.com/gtm.js?id=${encodeURIComponent(gtmId)}`,
				async: true,
				tagPriority: 'critical',
				tagPosition: 'head',
				'data-gtm': 'true',
			},
		],
	})
})
